















import {
    defineComponent,
} from '@vue/composition-api';
export default defineComponent({
    props: {
        isNoPrev: Boolean,
    },
    setup() {
        return {
        };
    },
});
